import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../../design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { ANIMATIONS } from '../../design-system/settings/variables/Animation';
import { TYPOGRAPHY } from '../../design-system/settings/variables/Typography';
import { DECORATORS } from '../../design-system/settings/variables/Decorators';

const StyledPopper = styled.tr`
  background-color: ${COLORS.whiteBase};
  padding: ${SPACERS.small} !important;
  margin-bottom: 40px;
  top: -10px;
`;

const StyledRow = styled.tr<{ onClick?: unknown }>`
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
  position: relative;
  padding: ${SPACERS.tiny} ${SPACERS.small};
  .popper {
    z-index: 20;
    pointer-events: none;
    position: absolute;
    right: 0;
    background-color: ${COLORS.whiteBase};
    padding: ${SPACERS.small};
    opacity: 0;
    transform: translateY(0);
    transition: all 0.15s ${ANIMATIONS.easing};
    &.active {
      transform: translateY(-72px);
      pointer-events: initial;
      opacity: 1;
      box-shadow: ${DECORATORS.boxShadowDefault};
    }
  }
  .email-group {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${SPACERS.tiny};
    svg {
      margin: 0;
    }
  }
  td {
    padding: ${SPACERS.small} ${SPACERS.small};
    &.primary,
    &.secondary {
      min-width: 222px;
    }
    &.secondary {
      img {
        border-radius: 50px;
        width: 24px;
        height: 24px;
        margin-right: ${SPACERS.tiny};
      }
    }
    &.nowrap {
      white-space: nowrap;
    }
    &.status {
      text-align: center;
    }
    svg {
      margin-right: ${SPACERS.tiny};
    }
  }
  th {
    position: relative;
    font-weight: ${TYPOGRAPHY.fontWeightBase};
  }
  th::before,
  th::after {
    content: '';
    display: block;
    position: absolute;
  }
  th::before {
    width: 1px;
    top: 0;
    bottom: 0;
    right: 0;
    box-shadow: 1px 0px 0px 0px ${COLORS.greyLight};
  }
  &:nth-child(even) {
    background-color: ${COLORS.greyLightest};
    th {
      background-color: ${COLORS.greyLightest};
    }
    &:hover {
      background-color: ${COLORS.greyLight};
      th {
        background-color: ${COLORS.greyLight};
      }
    }
    .hover-group {
      background: linear-gradient(
        270deg,
        #f8fbff 81.3%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }

  &:hover {
    & > * {
      background-color: ${COLORS.greyLight};
    }
    .hover-group {
      pointer-events: initial;
      opacity: 1;
      transform: translateX(0);
      right: 0;
      background: linear-gradient(
        270deg,
        #eaf0f6 81.3%,
        rgba(255, 255, 255, 0) 100%
      );
      .hover-button {
        background-color: ${COLORS.whiteBase};
      }
    }
  }
  .logo {
    display: inline-block;
    border-radius: 50px;
    overflow: hidden;
    width: 24px;
    height: 24px;
    margin-right: ${SPACERS.tiny};
    img {
      max-width: 100%;
    }
  }
`;

export interface TableHeaderId {
  id: number | string;
}

export interface GridTableRowProps<T> {
  index: number;
  headers: {
    width?: string;
    minWidth?: string;
    maxWidth?: string;
    text: string;
    Render: React.FC<{ row: T; index: number; className?: string }>;
  }[];
  row: T;
  onRowClick?: (
    e: React.MouseEvent<HTMLTableRowElement>,
    row: T,
    i: number,
  ) => unknown;
}

const GridTableRow = <T extends TableHeaderId>({
  headers,
  row,
  index,
  onRowClick,
}: GridTableRowProps<T>) => {
  const FirstColumn = headers[0].Render;
  const onClick = (e: React.MouseEvent<HTMLTableRowElement>) =>
    onRowClick?.(e, row, index);
  return (
    <StyledRow onClick={onRowClick ? onClick : undefined}>
      <th>
        {/* <td>
          <FontAwesomeIcon icon={faSquare} />
        </td> */}
        <FirstColumn index={-1} row={row} className="primary" />
      </th>
      {headers.slice(1).map(h => (
        <h.Render key={row.id} index={index} row={row} />
      ))}
      {/* <GridRowHoverGroup className="hover-group" /> */}
    </StyledRow>
  );
};

export default GridTableRow;
